"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_LIST = void 0;
const PRODUCT_LIST = exports.PRODUCT_LIST = 'product-list';
